module.exports = __webpack_public_path__ + "img/tema-1-15.169dba1a.png";